module.exports = __webpack_public_path__ + "static/img/14paint.d03842fb.png";